export const LOGICAL_OPERATORS = {
  AND: "AND",
  OR: "OR",
};

export const OPERATORS = {
  EQUAL: "EQUAL",
  EQUALS: "EQUALS",
  NOT_EQUAL: "NOT_EQUAL",
  GREATER: "GREATER",
  LESSER: "LESSER",
  GREATER_EQUAL: "GREATER_EQUAL",
  LESSER_EQUAL: "LESSER_EQUAL",
  CONTAINS: "CONTAINS",
  IS_EMPTY: "IS_EMPTY",
  IS_NOT_EMPTY: "IS_NOT_EMPTY",
};

export const INPUT_TYPES = {
  TEXTFIELD: "TEXTFIELD",
  EMAIL: "EMAIL",
  RADIO: "RADIO",
  NUMBER: "NUMBER",
  CHECKBOX: "CHECKBOX",
  SELECT: "SELECT",
  SLIDER: "SLIDER",
  DATEPICKER: "DATEPICKER",
  FILEUPLOAD: "FILEUPLOAD",
  IMAGEUPLOAD: "IMAGEUPLOAD",
  URL: "URL",
  MULTISELECT: "MULTISELECT",
  PHONE: "PHONE",
  TEXTAREA: "TEXTAREA",
  CHECKBOXGROUP: "CHECKBOXGROUP",
  RADIOGROUP: "RADIOGROUP",
  ICONRADIO: "ICONRADIO",
  MULTICHIP: "MULTICHIP",
  RICHTEXT: "INFO_TEXT",
  INFO_IMAGE: "INFO_IMAGE",
};

export const VIEW_MODES = {
  COPY_STEP: "COPY_STEP",
  BUILD_STEP: "BUILD_STEP",
};
